import React from 'react';
import { RouteComponentProps } from 'react-router';

import Page from './Page';

import { FeedTemplateForm } from '../components';
import { getProperty } from '../lib/api/property';
import { populate as populateProperty } from '../../shared/lib/property';
import { Property } from '../../shared/types/property';
import { FeedTemplate } from '../../shared/types/feedTemplate';

import './FeedLibrary.scss';
import { getFeedTemplatesByProperty, populate } from '../lib/api/feedTemplate';
import { getBrand } from '../lib/api/brand';
import { LoadingIndicator } from '@spark-labs/avocado-ui/dist/components/LoadingIndicator';
import { LibraryHeader, Button, DataTable, Popup } from '@spark-labs/avocado-ui';

export interface FeedLibraryProps {
  propertyId: string;
}

export interface FeedLibraryState {
  property?: Property;
  showFeedTemplateForm: boolean;
  feedTemplates: FeedTemplate[];
  /*
   * feedTemplateFormMode?: 'edit' | 'create';
   * selectedFeedTemplate?: FeedTemplate; */
}

export interface FeedLibraryParams {
  property: string;
}

type FeedLibraryPageProps = FeedLibraryProps & RouteComponentProps<FeedLibraryParams>;

const COLUMNS = ['Name'];
const COLUMN_WIDTHS = [100];

/**
 * Given an feed template, return a list of strings to show in the DataTable
 *
 */
function feedTemplateToRow(ft: FeedTemplate) {
  return [ft.name];
}

export default class FeedLibrary extends React.Component<FeedLibraryPageProps, FeedLibraryState> {
  public readonly state: FeedLibraryState = { showFeedTemplateForm: false, feedTemplates: [] };
  private propertyId: string;

  constructor(props: FeedLibraryPageProps) {
    super(props);
    this.propertyId = props.match.params.property;

    this.handleCloseForm = this.handleCloseForm.bind(this);
    this.handleAddFeedClick = this.handleAddFeedClick.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);

    /*
     *
     *
     * this.handleFormSubmit = this.handleFormSubmit.bind(this); */
  }

  public async componentDidMount() {
    let [bareProperty, feedTemplates] = await Promise.all([
      getProperty(this.propertyId),
      getFeedTemplatesByProperty(this.propertyId),
    ]);

    let brand = await getBrand(bareProperty.brand);
    let property = populateProperty(bareProperty, brand);

    this.setState({
      property,
      feedTemplates: feedTemplates.map(bf => populate(bf, property, [])),
    });
  }

  public render() {
    return (
      <Page className="FeedLibrary absolute flex items-stretch">
        <div className="SideMenu bg-blue-darkest flex flex-col">
          <div className="bg-white flex flex-col items-center pb-4">
            {this.state.property && <img src={this.state.property.brand.logo} />}
            <a href="#">
              <LibraryHeader size="sm">
                {this.state.property && this.state.property.brand ? (
                  this.state.property.brand.name
                ) : (
                  <LoadingIndicator size="small" className="mt-6" />
                )}
              </LibraryHeader>
            </a>
          </div>
          <div className="bg-blue-darker flex flex-col items-center py-4">
            <Button onClick={this.handleAddFeedClick} color="green">
              Add Feed
            </Button>
          </div>
        </div>
        <div className="LibraryBody flex-grow bg-blue-lightest flex flex-col">
          <div className="LibraryHeader mt-8 ml-16">
            <LibraryHeader>Feed Library</LibraryHeader>
          </div>

          <div className="LibraryTable mx-10 flex-grow overflow-auto">
            {
              <DataTable<FeedTemplate>
                elements={this.state.feedTemplates}
                onRowClick={this.handleRowClick}
                columnTitles={COLUMNS}
                rowFunction={feedTemplateToRow}
                columnWidths={COLUMN_WIDTHS}
              />
            }
          </div>
        </div>
        {this.state.showFeedTemplateForm && (
          <Popup title="Create Feed" onClose={this.handleCloseForm}>
            <FeedTemplateForm />
          </Popup>
        )}
      </Page>
    );
  }

  private closeFeedTemplateForm() {
    this.setState({ showFeedTemplateForm: false });
  }

  private handleCloseForm() {
    this.closeFeedTemplateForm();
  }

  private handleAddFeedClick() {
    this.setState({ showFeedTemplateForm: true });
  }

  private handleRowClick(feedTemplate: FeedTemplate) {
    console.log('x', feedTemplate);
  }

  /* private openCreateFeedTemplateForm() {
   *   if (!this.state.property) throw new Error('Invalid property');

   *   let newFeedTemplate = {
   *     _id: '',
   *     name: '',
   *     feed: '',
   *     property: this.state.property,
   *   };

   *   this.setState({
   *     showFeedTemplateForm: true,
   *     selectedFeedTemplate: newFeedTemplate,
   *     feedTemplateFormMode: 'create',
   *   });
   * }

   * private openUpdateFeedTemplateForm(feedTemplate: FeedTemplate) {
   *   this.setState({
   *     showFeedTemplateForm: true,
   *     selectedFeedTemplate: feedTemplate,
   *     feedTemplateFormMode: 'edit',
   *   });
   * }


   * private async loadFeedTemplates() {
   *   if (!this.state.property) throw Error(`Property is not defined`);
   *   let feedTemplates = (await getFeedTemplates(this.state.property._id)).map(ct =>
   *     populate(ct, this.state.property!)
   *   );
   *   this.setState({ feedTemplates });
   * }

   * private async handleFormSubmit(feedTemplate: FeedTemplate) {
   *   let bareFeedTemplate = bare(feedTemplate);
   *   if (this.state.feedTemplateFormMode === 'edit') {
   *     await update(bareFeedTemplate);
   *   } else if (this.state.feedTemplateFormMode === 'create') {
   *     delete bareFeedTemplate._id;
   *     await create(bareFeedTemplate as NewFeedTemplate);
   *   }

   *   await this.loadFeedTemplates();
   *   this.closeFeedTemplateForm();
   * }
   */
}
